export interface ViewActionsContainerProps {
    children: React.ReactNode;
}

export function ViewActionsContainer(props: ViewActionsContainerProps) {
    return <div {...props} style={{ marginBottom: '20px' }}></div>;
}
